<template>
  <div
    v-show="isShow"
    class="contextmenu"
    ref="contextmenu"
    :style="{
      left: containerParam.left + 'px',
      top: containerParam.top + 'px',
    }"
  >
    <div class="item"></div>
    <div class="item">
      <el-button
        style="width: 100%"
        size="mini"
        type="primary"
        class-name="hl_miniBtn"
        @click="detail($event)"
        >按钮</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "Contextmenu",
  props: ["map"],
  inject: [],
  components: {},
  data() {
    return {
      mapContextMenu: this.$store.getters.mapContextMenu,
      isShow: false,
      containerParam: {
        left: "",
        top: "",
        longitude: "",
        latitude: "",
      },
      param: "", // 选中的数据
    };
  },
  watch: {
    "mapContextMenu.selected": {
      handler(v) {
        this.isShow = false;
        if (!this.checkLayer(v)) {
          this.removeEvent();
          return;
        }
        this.$nextTick(() => {
          this.isShow = v.isShow;
          if (this.isShow) {
            this.setContainerParam(v);
            this.addEvent();
          } else this.removeEvent();
        });
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    checkLayer(v) {
      if (!v.layerId) return false;
      let flag = false;
      let layers = this.$mapValue.layer;
      for (let key in layers) {
        if (layers[key].layerId === v.layerId && layers[key].rightContext)
          flag = true;
      }
      return flag;
    },
    addEvent() {
      this.removeEvent();
      if (this.isShow)
        this.moveendEvt = this.map.on("moveend", () => {
          this.isShow = true;
          this.$nextTick(() => {
            let newPixel = this.map.getPixelFromCoordinate([
              this.containerParam.longitude,
              this.containerParam.latitude,
            ]);
            this.containerParam.left = newPixel[0];
            this.containerParam.top = newPixel[1];
          });
        });
      if (this.isShow)
        this.movestartEvt = this.map.on("movestart", () => {
          this.isShow = false;
        });
    },
    removeEvent() {
      this.mapApi.unByKey(this.moveendEvt);
      this.mapApi.unByKey(this.movestartEvt);
    },
    // 设置容器参数
    setContainerParam(v) {
      this.param = v.feature.getProperties();
      this.containerParam.left = v.pixel[0];
      this.containerParam.top = v.pixel[1];
      this.containerParam.longitude = this.param.longitude;
      this.containerParam.latitude = this.param.latitude;
    },
    detail(evt) {
      evt.stopPropagation();
      this.$message.success(this.$mapValue.keys.right_click_context);
    },
  },
};
</script>
<style lang="scss" scoped>
.contextmenu {
  position: absolute;
  width: auto;
  height: auto;
  padding: 10px;
  z-index: 99;
  color: black;
  border-radius: 5px;
  list-style: none;
  background-color: #ffffff;
  //   border: 1px solid #2e8de5;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  .item {
    line-height: 30px;
    width: 100%;
  }
}
</style>
